export var ToolbarAction;
(function (ToolbarAction) {
    ToolbarAction[ToolbarAction["BOLD"] = 1] = "BOLD";
    ToolbarAction[ToolbarAction["ITALIC"] = 2] = "ITALIC";
    ToolbarAction[ToolbarAction["HEADING"] = 3] = "HEADING";
    ToolbarAction[ToolbarAction["UNORDERED_LIST"] = 4] = "UNORDERED_LIST";
    ToolbarAction[ToolbarAction["ORDERED_LIST"] = 5] = "ORDERED_LIST";
    ToolbarAction[ToolbarAction["IMAGE"] = 6] = "IMAGE";
    ToolbarAction[ToolbarAction["FORMULA"] = 7] = "FORMULA";
    ToolbarAction[ToolbarAction["HYPERLINK"] = 8] = "HYPERLINK";
    ToolbarAction[ToolbarAction["STRIKE_THROUGH"] = 9] = "STRIKE_THROUGH";
    ToolbarAction[ToolbarAction["TABLE"] = 10] = "TABLE";
    ToolbarAction[ToolbarAction["IMG2TXT"] = 11] = "IMG2TXT";
})(ToolbarAction || (ToolbarAction = {}));
export var ToolbarActionState;
(function (ToolbarActionState) {
    ToolbarActionState[ToolbarActionState["INACTIVE"] = 0] = "INACTIVE";
    ToolbarActionState[ToolbarActionState["ACTIVE"] = 1] = "ACTIVE";
    ToolbarActionState[ToolbarActionState["DISABLED"] = 2] = "DISABLED";
})(ToolbarActionState || (ToolbarActionState = {}));
